import React from 'react';
import './InlineLoader.css'

const InlineLoader = props => 
      <span className='inline-loader'>
            <span className="load-5">
                <div className="ring-2">
                    <div className="ball-holder">
                        <div className="ball"></div>
                    </div>
                </div>
            </span>
      </span>


export default InlineLoader;



// WEBPACK FOOTER //
// ./src/components/InlineLoader.js